import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.res = languageMap.rescript = bracketIndenting()
